import { createSelector } from 'reselect';

const getUnreadMessages = state => Object.values(state.notification.unreadMessageItems);
const getUnreadFinances = state => Object.values(state.notification.unreadFinanceItems);
const getUnreadUpdates = state => Object.values(state.notification.unreadUpdateItems);

const getOrdersProgressIds = state => state.ordersProgress.numbers.map(number => state.orders[number]._id);
const getOrdersCompleteIds = state => state.ordersComplete.numbers.map(number => state.orders[number]._id);

export const getHasUnreadMessages = createSelector(
    [getUnreadMessages],
    unreadMessages => !!unreadMessages.length
);

export const getHasUnreadFinances = createSelector(
    [getUnreadFinances],
    unreadFinances => !!unreadFinances.length
);

export const getHasUnreadInboxItems = createSelector(
    [getUnreadUpdates],
    unreadUpdates => !!unreadUpdates.length
);

export const getHasUnreadMessagesOrdersProgress = createSelector(
    [getUnreadMessages, getOrdersProgressIds],
    (unreadMessages, ordersProgressIds) => unreadMessages.some(messageItem => ordersProgressIds.indexOf(messageItem.order) > -1)
);

export const getHasUnreadMessagesOrdersComplete = createSelector(
    [getUnreadMessages, getOrdersCompleteIds],
    (unreadMessages, ordersCompleteIds) => unreadMessages.some(messageItem => ordersCompleteIds.indexOf(messageItem.order) > -1)
);

export const getOrderIdsWithUnreadMessages = createSelector(
    [getUnreadMessages],
    unreadMessages => [...unreadMessages.reduce((result, item) => {
        result.add(item.order);
        return result;
    }, new Set())]
)


// WEBPACK FOOTER //
// ./src/store/notification/selectors.js